<template>
  <div class="user-avatar-view">
    <img v-if="props.src" :src="props.src" :alt="props.src">
    <img v-else src="@/assets/avatar-b.png" alt="默认头像">
  </div>
</template>

<script lang="ts" setup>
// eslint-disable-next-line no-undef
const props = defineProps(['src', 'alt'])
</script>

<style lang="less" scoped>
.user-avatar-view {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  overflow: hidden;

  img {
    display: block;
    width: 100%;
    height: 100%;
  }
}
</style>